export class EquipmentService {
  #equipmentUI;

  #autoRefreshItems = true;
  #allowRareItemSystem = true;
  #goldItemId = 0;
  #inventorySortEquip = true;
  #qualitySystemColor = false;

  #allowEquipsStats = true;
  #showFullEquipedStats = false;

  #staticDescPosition = true;
  #staticDescPosXY = {
    x: 844,
    y: 217
  }

  #sizeCellParameters = {
    iconSize: 110,
    columnsPerPage: 6,
    rowsPerPage: 3,
    iconMode: 1
  }

  // _extraDescriptions = [
  //   {
  //     itemId: 5,
  //     weaponId: 0,
  //     armorId: 0,
  //     picture: {
  //       imgName: "card_back", size: { w: 100, h: 100 },
  //       position: { x: 50, y: 50}
  //     },
  //     info: {
  //       font: { face: "", size: 24, italic: false },
  //       text: "This is \C[3] some example \C[0] description",
  //       size: { w: 100, h: 100},
  //       position: { x: 50, y: 50 }
  //     }
  //   }
  // ];
  _extraDescriptions = [];

  showScene() {
    Yosemite.TopBar.enable(false);
    Yosemite.Equipment.viewScene();
  }

  setUI(equipmentUI) {
    this.#equipmentUI = equipmentUI;
  }

  openInventory() {
    if(this.#equipmentUI) this.#equipmentUI.openInventory();
  };

  closeInventory() {
    if(this.#equipmentUI) this.#equipmentUI.closeInventory();
  };

  hideUI() {
    if(this.#equipmentUI) this.#equipmentUI.visible = false;
  };

  showUI() {
    if(this.#equipmentUI) this.#equipmentUI.visible = true;
  };

  openOrCloseInventory() {
    if (this.isInventoryOpened()) {
      this.closeInventory();
    } else {
      this.openInventory();
    }
  };

  isInventoryOpened() {
    return (this.#equipmentUI) ? this.#equipmentUI.isInventoryOpen() : false;
  };

  invShowNextPage() {
    if(this.#equipmentUI) this.#equipmentUI.showNextInvPage();
  };

  invShowPrevPage() {
    if(this.#equipmentUI) this.#equipmentUI.showPrevInvPage();
  };

  onInvCellClick(index) {
    if(this.#equipmentUI && this.#equipmentUI.visible) {
      this.#equipmentUI.clickInvItem(index)
    }
  };

  invShowCategoryItems() {
    if(this.#equipmentUI) this.#equipmentUI.openCategory(0);
  };

  invShowCategoryWeapons() {
    if(this.#equipmentUI) this.#equipmentUI.openCategory(1);
  };

  invShowCategoryArmors() {
    if(this.#equipmentUI) this.#equipmentUI.openCategory(2);
  };

  invShowCategoryKeyItems() {
    if(this.#equipmentUI) this.#equipmentUI.openCategory(3);
  };

  refreshInventory() {
    if(this.#equipmentUI) this.#equipmentUI.refreshInventory();
  };

  onInvCellFocusedClick(index) {
    if(this.#equipmentUI) this.#equipmentUI.clickInvFocusedItem(index);
  };

  closeInventoryByClick() {
    if (!this.#equipmentUI) return;
    if (!this.#equipmentUI.inventory) return;
    if (this.#equipmentUI.inventory.isSomeItemFocused()) return;

    this.#equipmentUI.closeInventory();
  };

  isGoldItem(item) {
    if (!item) return false;

    if (this.getGoldItemId() > 0) {
      return item.id === this.getGoldItemId();
    } else {
      return false;
    }
  }

  isCellUnderRightClick() {
    if (!this.#equipmentUI) return false;
    if (!this.#equipmentUI.isMouseInInventory()) return false;

    const openedInstance = this.#equipmentUI.openedInstance();
    const cellUnderMouse = openedInstance.isSomeCellUnderMouse();

    return !!cellUnderMouse;
  };

  IsHaveExtraInfo(item) {
    return this.GetExtraInfo(item) !== null;
  };

  GetExtraInfo(item) {
    const data = YsServices.equipmentService.getExtraInfoData();
    if (data.length === 0) return null;

    let searchField = "itemId";
    if (DataManager.isWeapon(item)) {
      searchField = "weaponId";
    } else if (DataManager.isArmor(item)) {
      searchField = "armorId";
    }

    for (let i = 0; i < data.length; i++) {
      const infoItem = data[i];
      if (infoItem[searchField] === item.id) {
        return infoItem;
      }
    }

    return null;
  };

  GetColorForQuealityLevel(qualityLevel) {
    const settings = YsServices.equipmentService.getUIMapInventorySettings();
    const levelData = settings.QualitySystem.Levels[qualityLevel];
    if (!levelData) return KDCore.Color.WHITE.CSS;
    return KDCore.Color.FromHex(levelData[1]).CSS;
  }

  FromImgI(filename) {
    return KDCore.Sprite.FromImg(filename, 'pMapInventory');
  };

  getUIMapInventorySettings() {
    return $MapInventorySettings;
  };

  getSizeCellsParameter() {
    return this.#sizeCellParameters;
  }

  // Auto Inventory Refresh. May cause lower game performance if inventory have many items
  get_AutoRefreshItems() {
    return this.#autoRefreshItems;
  }

  // Allow Item Quality System. If true, you can set quality level to items, using Note command
  get_AllowRareSystem() {
    return this.#allowRareItemSystem;
  }

  // Items names with quality colors. If true, item name color in Map Inventory will be same as item quality level color
  isShowItemNameWithQualityColor() {
    return this.#qualitySystemColor;
  }

  // Allow Equipments. If true, you can see extra information (mouse scroll)
  get_AllowEquipStats() {
    return this.#allowEquipsStats;
  }

  // Show already equiped items (armor, weapon) in inventory?
  get_ShowEquipedItemsInInventory() {
    return true;
  }

  // Sort Items. Usable items show first in inventory
  get_MapInventorySortItems() {
    return true;
  }

  // Gold Item. Item template for gold in visual chest, if 0 - just receive gold directly
  getGoldItemId() {
    return this.#goldItemId;
  }

  // Sort Equipments. Equipped items (armors, weapon) show first in inventory
  get_MapInventorySortEquips() {
    return this.#inventorySortEquip;
  };

  // Show full stats when equipped. If false, when item is equipped you can see only gained stats (without actor ones)
  get_AllowFullStats() {
    return this.#showFullEquipedStats;
  }

  // Description static position. If true, description will be always in X, Y coordinates you set, not near the cursor
  isStaticDescPosition() {
    return this.#staticDescPosition;
  }

  // X and Y coordinates for description window static position
  // example {"x:e":"0","y:e":"0"}
  getStaticDescPosition() {
    return this.#staticDescPosXY;
  }

  // Extra Descriptions. Description text for item when you press left mouse button on it
  getExtraInfoData() {
    return this._extraDescriptions;
  }
}
